import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { UtilFns } from '@utils';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { AuthService } from '../../services/auth.service';

@Component({
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./auth-shell.scss'],
  imports: [InputTextModule, ButtonModule, FormsModule, RouterModule],
})
export class ConfirmEmailComponent implements OnInit {
  error = '';
  success = '';
  working = false;
  code = '';
  userId = '';
  changedEmail = '';

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    const params = UtilFns.parseUrlParams(location);
    this.code = params.get('code') || '';
    this.userId = params.get('userId') || '';
    this.changedEmail = params.get('changedEmail') || '';

    if (!this.code || !this.userId) {
      this.error = "Invalid confirmation link";
    } else {
      this.submit();
    }
  }

  private async submit() {
    this.error = '';
    if (this.working) { return; }

    this.working = true;
    try {
      const result = await this.authService.confirmEmail(this.userId, this.code, this.changedEmail);
      this.error = '';
      // The "already confirmed" path is the documented silent-failure case (see
      // onboarding-flow memory): the email was confirmed on a previous click, so
      // the confirm token has been consumed and would normally surface as a
      // misleading "Unable to confirm" error. Present it as success instead, since
      // mission-accomplished is the actual state.
      this.success = result.alreadyConfirmed
        ? 'This email address is already confirmed. Please log in.'
        : 'Your email address has been confirmed.';
      this.working = false;

      // First confirmation of an invited user: the server hands back a password-reset token, so
      // finish the job here rather than logging them out. Onboarding used to stop at this screen
      // and expect the user to find "Forgot Password" unprompted, which is where new users were
      // being lost. The token is absent on the already-confirmed and change-email paths, and
      // those still fall through to the logout below.
      if (result.resetCode && result.userName) {
        await this.router.navigate(['/auth/new-password'], {
          queryParams: { code: result.resetCode, email: result.userName, confirmed: '1' },
        });
        return;
      }

      setTimeout(() => this.authService.logout(), 5000);

    } catch (err: any) {
      if (err.status === 0) {
        this.error = 'Unable to contact server';
      } else {
        console.error(err);
        this.error = 'Unable to confirm email';
      }
      this.working = false;
    }
  }

  async logout() {
    this.authService.logout();
  }

}
